<template>
  <div class="settings card_flex">
    <div class="card_add form-group">
      <span
        class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
        @click.prevent="new_channel"
      >{{ translate('notification.to_add') }}</span>
    </div>
    <div class="response_table card_table">
      {{translate('notification.channels_my')}}
      <table>
        <thead style="flex:0;">
          <tr>
            <th scope="col"> {{ translate('notification.ch_name') }} </th>
            <th scope="col"> {{ translate('notification.ch_type') }} </th>
            <th scope="col"> {{ translate('notification.ch_params') }} </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="load" style="border:none; background-color:  transparent;">
            <td> <scale-loader /> </td>
          </tr>
          <tr v-for="(channel,key) in channels.my" :key="key" @click.prevent="new_channel(channel)">
            <td :data-label="translate('notification.ch_name')">{{ channel.name }}</td>
            <td :data-label="translate('notification.ch_type')">{{ channel.type }}</td>
            <td :data-label="translate('notification.ch_params')">{{ channel.params }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="response_table card_table"  v-if="this.$store.getters.getPermissions.permissionGod === true">
      {{translate('notification.channels_all')}}
      <table>
        <thead style="flex:0;">
          <tr>
            <th scope="col"> {{ translate('notification.ch_name') }} </th>
            <th scope="col"> {{ translate('notification.ch_type') }} </th>
            <th scope="col"> {{ translate('notification.ch_params') }} </th>
            <th scope="col"> {{ translate('notification.ch_username') }} </th>
            <th scope="col"> {{ translate('notification.ch_clientname') }} </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="load" style="border:none; background-color:  transparent;">
            <td> <scale-loader /> </td>
          </tr>
          <tr v-for="(channel,key) in channels.all" :key="key" @click.prevent="new_channel(channel)">
            <td :data-label="translate('notification.ch_name')">{{ channel.name }}</td>
            <td :data-label="translate('notification.ch_type')">{{ channel.type }}</td>
            <td :data-label="translate('notification.ch_params')">{{ channel.params }}</td>
            <td :data-label="translate('notification.ch_username')">{{ channel.username }}</td>
            <td :data-label="translate('notification.ch_clientname')">{{ channel.clientname }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import SettingsEdit from './Settings/SettingsEdit'

export default {
  name: 'SettingEdit',
  components: {

  },
  data () {
    return {
      load: true,
      init: false,
      channels: []
    }
  },
  computed: {
  },
  mounted () {
    this.getChannels()
  },
  methods: {
    new_channel (val) {
      var t = this.$createElement(SettingsEdit, {props: {channel: val}, on: {close: () => { this.$modal.hide('dynamic-modal') }, update: (val) => { this.update(val) }, delete: (val) => { this.delete_channel(val) },}})
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
    getChannels () {
      this.$http.v1.getNotificationChannelsList((response) => {
        this.load = false
        this.init = false
        this.channels = response.data
      })
    },
    save_channel (val) {
      this.$http.v1.saveNotificationChannel(val, () => {
        this.getChannels()
        this.global_notify('info', this.translate('notification.channel.saved'))
      })
    },
    delete_channel (val) {
      this.$http.v1.deleteNotificationChannel(val, () => {
        this.getChannels()
        this.global_notify('info', this.translate('notification.channel.deleted'))
      })
    },
    update (val) {
      if (val.id !== undefined) {
        this.channels[val.id] = val
      }
      this.save_channel(val)
    }
  }
}
</script>

<style lang='scss'>

  .settings{
    height: 100%;

    border-radius: 3px;
    color: #252422;
    padding-bottom: 10px;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;

    .card{
      &_add{
        padding: 0 10px;
        .btn{
          width: 40%;
          display: inline-block;
          margin-top: 10px;
          padding: 0 2px 1px 0;
          white-space: normal;
          height: 22px;
          line-height: 18px;
          border-radius: 5px;
        }
      }
      &_table{
        padding: 0 10px;
      }
    }

    &.card_flex{
      .card_add{
        flex: inherit;
      }
    }

  }

  @media (max-width:768px) {
    .settings{
      .card{
        &_add{
          .btn{
            width: 100%;
          }
        }
      }
    }

  }
</style>
